import { EventEmitter } from "./utils/EventEmitter";
import { fromEvent, Observable, Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged, map, publishReplay, refCount, scan, startWith } from "rxjs/operators";
export class Geocoder extends EventEmitter {
    _inputField;
    _autocompleteSubscription;
    _configuration$;
    _configurationSubject$ = new Subject();
    constructor(inputField) {
        super();
        this._autocompleteSubscription = new Subscription();
        this._inputField = inputField;
        this._configuration$ = this._configurationSubject$.pipe(startWith(this.defaultConfiguration), scan((conf, newConf) => {
            for (const key in newConf) {
                if (newConf[key] && (typeof newConf[key] != "object" || Array.isArray(newConf[key]))) {
                    conf[key] = newConf[key];
                }
                else if (newConf[key] && typeof newConf[key] == "object" && !Array.isArray(newConf[key])) {
                    const nestedConf = conf[key] || {};
                    for (const nested_key in newConf[key]) {
                        if (newConf[key][nested_key]) {
                            nestedConf[nested_key] = newConf[key][nested_key];
                        }
                    }
                    conf[key] = nestedConf;
                }
            }
            return conf;
        }), publishReplay(1), refCount());
        this._configuration$.subscribe(() => {
            /*noop*/
        });
    }
    inputSearch$(debouncetime = 300) {
        return fromEvent(this._inputField, "input").pipe(debounceTime(debouncetime), map((event, _) => {
            return event.target.value;
        }), distinctUntilChanged());
    }
    startAutocomplete() {
        this._autocompleteSubscription = this.query$.subscribe((resp) => {
            this.fire("autocomplete", resp);
        });
    }
    stopAutocomplete() {
        this._autocompleteSubscription.unsubscribe();
    }
    get defaultConfiguration() {
        return this._getDefaultConfiguration();
    }
    configure(conf) {
        this._configurationSubject$.next(conf);
    }
    get configuration$() {
        return this._configuration$;
    }
}
//# sourceMappingURL=geocoder.js.map